<template>
    <div v-if="client" class="client-settings-view-menu">
        <!-- menu items -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Menu items</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <draggable :list="links">
                            <div class="menu-item" v-for="menuItem in links" :key="menuItem.name">
                                <span class="icon is-small">
                                    <i class="fas fa-grip-vertical"></i>
                                </span>
                                {{ menuItem.name }}
                                <input v-model="menuItem.enabled" type="checkbox" class="checkbox" />
                            </div>
                        </draggable>
                    </div>
                </div>
            </div>
        </div>

        <!-- save -->
        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="save" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import state from '../../../../../state';
import utils from '../../../../../utils';
import clientService from '../../../../../services/client.service';
import gamesListService from '../../../../../services/gamesList.service';

import Draggable from 'vuedraggable';

export default {
    name: 'client-settings-view-menu',
    components: { Draggable },
    data() {
        return {
            client: null,
            links: [],
            allLinks: [
                'slots',
                'video-games',
                'virtual-sports',
                'live-casino',
                'covid',
                'sport-home',
                'sport-prematch',
                'sport-live',
                'sport-results',
                'sport-lottery',
                'sport-autoexpress',
                'softgamings',
                'promotions',
                'virtuals',
                'shooting',
                'races',
                'fast',
                'crash',
                'mobile-instruction',
                'aviatrix',
                'vegas',
                'poker',
                'tv-games',
                'scratch-games',
                'table-games',
                'results',
                'referrals',
                'toto',
            ]
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        }
    },
    watch: {
        clientId() {
            this.loadClient();
        }
    },
    async mounted() {
        await clientService.ensure();
        await this.loadClient();
    },
    methods: {
        async loadClient() {
            this.client = utils.clone(state.clients.getClient(this.clientId));

            let gamesLists = await gamesListService.getClientGamesLists(this.clientId);
            gamesLists.forEach(gl => this.allLinks.push(gl.name));

            this.links = [];
            this.client.settings.viewSettings.categories.menuItems.forEach(mi => {
                this.links.push({
                    name: mi,
                    enabled: true
                });
            });
            this.allLinks.forEach(l => {
                let exists = this.links.find(el => el.name === l);
                if (!exists) {
                    this.links.push({ name: l, enabled: false });
                }
            });
        },
        async save() {
            this.client.settings.viewSettings.categories.menuItems = [];
            this.links.forEach(l => {
                if (l.enabled) {
                    this.client.settings.viewSettings.categories.menuItems.push(l.name);
                }
            });
            await clientService.save(this.client);
            this.loadClient();
        }
    }
};
</script>
<style lang="scss">
.client-settings-view-menu {
    .menu-item {
        margin-bottom: 0.32rem;
        padding: 0.4rem 0.8rem;
        width: 240px;
        border: 1px solid #666;
        border-radius: 0.2rem;
        background-color: #333;

        .icon {
            margin-right: 0.2rem;
        }

        .checkbox {
            float: right;
        }
    }
}
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/view/menu.vue